import { BaseEntity, Entity as DecribeEntity, Relation } from '@avangard/utils/entity';

import { FileInfoEntity } from './file-info-entity';

import type { FileDoc } from '@modules/types/graphql';

export type Entity = Partial<FileDoc> | null;

@DecribeEntity('FileDocumentEntity')
class FileDocumentEntity extends BaseEntity {
    name: string;
    fileId: string;

    @Relation(() => FileInfoEntity)
    file: FileInfoEntity;

    constructor(subject: Entity) {
        super(subject);

        this.name = subject?.name ?? '';
        this.fileId = subject?.fileId ?? '';
    }
}

export { FileDocumentEntity };
